import { render, staticRenderFns } from "./FactorialMaterialExportList.vue?vue&type=template&id=6ff2a90c&scoped=true"
import script from "./FactorialMaterialExportList.vue?vue&type=script&lang=js"
export * from "./FactorialMaterialExportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2a90c",
  null
  
)

export default component.exports